import type {
  Dispensaries,
  DutchiePosLoyaltyConfig,
  EnterpriseLoyaltySettingsQuery,
  RewardsListV2,
} from 'src/gql/graphql';
import type { GeoPoint } from 'src/utils/geo/nearest-store';

export type Enterprise = EnterpriseLoyaltySettingsQuery['enterpriseLoyaltySettings'];

export type EnterpriseSignupProps = {
  /** Server-resolved visitor location (POS-17999), null if unavailable. See page.tsx. */
  visitorGeo?: GeoPoint | null;
};

export const FLOW_STEPS = {
  LANDING: 'landing',
  LOGIN_METHOD: 'login-method',
  EMAIL_SIGNUP: 'email-signup',
  LOYALTY_REWARDS: 'loyalty-rewards',
} as const;

export type FlowStep = typeof FLOW_STEPS[keyof typeof FLOW_STEPS];

export type BrandingStatus = 'custom' | 'fallback' | 'loading';

export type LandingPageProps = {
  enterprise: Enterprise;
  onStartEarningRewards: (selectedState: string) => void;
  /** Fired as soon as a state is known for theming (POS-17999), before the user clicks/confirms. */
  onLikelyStateDetected?: (stateCode: string) => void;
  /** Best dispensary available to theme from (POS-17999). */
  themeDispensary?: Dispensaries | null;
  /** Frozen loading decision for this mount: late theme results cannot restyle fallback controls. */
  brandingStatus?: BrandingStatus;
  /** Server-resolved visitor location (POS-17999), skips the geolocation permission prompt when known. */
  visitorGeo?: GeoPoint | null;
};

export type LoginMethodSelectionProps = {
  onContinueWithEmail: () => void;
  themeDispensary?: Dispensaries | null;
  brandingStatus?: BrandingStatus;
  /** POS-23112 -- mark this form's Google popup to hand its token back. See src/oauth/embedded-loyalty-signup-popup.ts. */
  isEmbeddedLoyaltySignupPopupFlow?: boolean;
  /** POS-23112 -- which provider was just submitted; only Google completes the login step. */
  onSocialSubmit?: (provider: 'apple' | 'google') => void;
};

export type LoyaltyRewardsProps = {
  enterprise: Enterprise;
  rewards?: RewardsListV2 | null;
  loyaltyConfigData?: DutchiePosLoyaltyConfig | null;
  rewardsDataLoading?: boolean;
  loyaltyConfigLoading?: boolean;
  isEmbedMode?: boolean;
};
